<script setup>
    import { reactive, watch, computed } from 'vue'
    import Error from "../../firebase_settings/error.js"

    const emit = defineEmits(['executeMethod']);

    //パスワードの値を保持するリアクティブオブジェクト
    const reactiveObj = reactive({
        //ソートを行う項目のオブジェクト
        sortItems: {
            //1つ目の項目
            item1: {
                //契約開始月（固定）
                itemName: "ContractStartDate",
                //降順（固定）
                sort: "desc"
            },
            //2つ目の項目
            item2: {
                //任意（空白）
                itemName: "",
                //任意（空白）
                sort: ""
            }
        },
        //親コンポーネントに返す並び順のリスト
        sortItemList: [],
        //アラートフラグ
        alertFlag: false
    })
    //リアクティブオブジェクトのリセット
    const valueReset = () => {
        reactiveObj.sortItemList = []
    }
    //全ての入力フォームが入力されたときに変更ボタンを活性化させる
    const inputSomeData = () => {
        //変更ボタンの活性化フラグ
        let equalFlag = false
        //全ての入力フォームが入力されたときに変更ボタンの活性化フラグをTrueにする
        for(let index = 1; index <= Object.keys(reactiveObj.sortItems).length; index++) {
            document.querySelectorAll(`select.sortItem${index}`)[0].value || reactiveObj.alertFlag ? equalFlag = true : null
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag ? document.getElementById('commonButtonSort').disabled = false: document.getElementById('commonButtonSort').disabled = true
    }
    //選択した項目は他の項目では非活性にする
    const checkItem = (num) => {
        //優先度の項目の数だけ繰り返し
        for(let index = 1; index <= Object.keys(reactiveObj.sortItems).length; index++) {
            //現在選択されている値を取得
            const SortItem = document.querySelectorAll(`select.sortItem${num}`)[0].value
            //選択した番号のDOMならスキップ
            if(index == num) {
                continue
            }
            //選択した番号のDOM以外
            else {
                //対象のセレクトボックスを取得
                const listItems = document.querySelectorAll(`select.sortItem${index}`)
                //選択肢の数だけ繰り返し
                for(let listItem of listItems[0]) {
                    //選択されている値と同一なら非活性化
                    if(listItem.value == SortItem) {
                        listItem.disabled = true
                    }
                    //そうでないなら活性化
                    else {
                        listItem.disabled = false
                    }
                }
            }
        }
        //入力チェック
        inputSomeData()
    }
    //モーダルウィンドウが閉じるときに実行
    const exitModal = (sortFlag) => {
        //優先度の項目の数だけ繰り返し
        for(let index = 1; index <= Object.keys(reactiveObj.sortItems).length; index++) {
            //優先度の項目と並び順に値が選択されていること
            if(document.querySelectorAll(`select.sortItem${index}`)[0].value && document.querySelectorAll(`select.sortSelect${index}`)[0].value) {
                //親コンポーネントに返す値を格納
                reactiveObj.sortItemList.push({
                    //優先度の項目
                    key: document.querySelectorAll(`select.sortItem${index}`)[0].value,
                    //並び順
                    order: document.querySelectorAll(`select.sortSelect${index}`)[0].value
                })
            }
            //片方しか設定されていない場合には選択肢をリセット
            else {
                reactiveObj.sortItems[`item${index}`].itemName = ''
                reactiveObj.sortItems[`item${index}`].sort = ''
            }
        }
        //親コンポーネントに編集の是非とその値を渡す
        emit('executeMethod', sortFlag, reactiveObj.alertFlag, reactiveObj.sortItemList);
        document.getElementById('commonButtonSort').disabled = true
        //モーダルウィンドウを閉じる際に追加ボタンを非活性化
        valueReset()
    }
    //優先度1の項目に関する算出プロパティ
    const getItem1 = computed({
        get: () => {
            return reactiveObj.sortItems.item1.itemName
        },
        set: (value) => {
            reactiveObj.sortItems.item1.itemName = value
            document.getElementById('sortItem1').value = value
        }
    })
    //優先度1の並び順に関する算出プロパティ
    const getSort1 = computed({
        get: () => {
            return reactiveObj.sortItems.item1.sort
        },
        set: (value) => {
            reactiveObj.sortItems.item1.sort = value
            document.getElementById('sortSelect1').value = value
        }
    })
    //優先度2の項目に関する算出プロパティ
    const getItem2 = computed({
        get: () => {
            return reactiveObj.sortItems.item2.itemName
        },
        set: (value) => {
            reactiveObj.sortItems.item2.itemName = value
            document.getElementById('sortItem2').value = value
        }
    })
    //優先度2の並び順に関する算出プロパティ
    const getSort2 = computed({
        get: () => {
            return reactiveObj.sortItems.item2.sort
        },
        set: (value) => {
            reactiveObj.sortItems.item2.sort = value
            document.getElementById('sortSelect2').value = value
        }
    })
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
</script>

<template>
    <div class="modalArea">
        <div id="modalContent" class="modal">
            <p class="modalTitle">並び替え</p>
            <div class="modalInfo">
                <p>優先度1の項目</p>
                <select class="sortItem1" id="sortItem1" v-model="getItem1" @change="checkItem('1')">
                    <option value="ContractStartDate" selected>契約開始月</option>
                    <option value="CorporateId">企業コード</option>
                    <option value="remainingUserCount">ユーザー残数</option>
                    <option value="remainingTerminalCount">デバイス残数</option>
                </select>
                <select class="sortSelect1" id="sortSelect1" v-model="getSort1" >
                    <option value="asc">昇順</option>
                    <option value="desc" selected>降順</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>優先度2の項目</p>
                <select class="sortItem2" id="sortItem2" v-model="getItem2" @change="checkItem('2')">
                    <option value="ContractStartDate" disabled>契約開始月</option>
                    <option value="CorporateId">企業コード</option>
                    <option value="remainingUserCount">ユーザー残数</option>
                    <option value="remainingTerminalCount">デバイス残数</option>
                </select>
                <select class="sortSelect2" id="sortSelect2" v-model="getSort2" >
                    <option value="asc">昇順</option>
                    <option value="desc">降順</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>アラートのみ表示する</p>
                <div class="switchArea">
                    <p class="switchLabel" v-if = "reactiveObj.alertFlag">する</p>
                    <p class="switchLabel" v-else>しない</p>
                    <label>
                        <input type="checkbox" v-model="reactiveObj.alertFlag">
                        <div id="swImg"></div>
                    </label>
                </div>
            </div>
            <button type="button" id="commonButtonSort" @click="exitModal(true)" disabled>並べ替える</button>
        </div>
        <div class="modalOverlay" @click.self="exitModal(false)"></div>
    </div>
</template>

<style scoped>
    .modal {
        width: 800px;
        height: 400px;
        top: 50%;
        left: 50%;
    }
    #commonButtonSort {
        width: 190px;
        height: 70px;
        top: 60px;
        left: 50%;
    }
    .modalInfo {
        display: flex;
        flex-direction: row;
        padding: 0 3% 0 3%;
    }
    .modalInput, select[class^="sortItem"] {
        height: 50px;
        width: 395%;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    select[class^="sortSelect"] {
        height: 50px;
        width: 100%;
        margin: 0 0 0 5%;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    .switchArea {
        width: 400%;
        height: 50px;
        left: 0;
        p {
            left: -55px;
            width: 50px;
            text-align: left;
        }
    }
    @media (max-width: 1000px) {
        .modal {
            width: 85%;
            height: 700px;
            display: flex;
            justify-content: left;
            align-items: left;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .modal p {
            padding: 10px 0 10px 0;
        }
        .modalInfo {
            flex-direction: column;
            padding: 3% 0 3% 0;
        }
        .modalInfo p {
            top: 0%;
            width: 100%;
            max-width: 100%;
            font-size: 16px;
        }
        .modalInput, select[class^="sortItem"] {
            height: 50px;
            width: 100%;
            border-radius: 10px;
            border: solid 3px #d7d7d7;
            background-color: #d7d7d7;
        }
        select[class^="sortSelect"] {
            height: 50px;
            width: 100%;
            margin: 5% 0 5% 0;
            margin-left: auto;
            border-radius: 10px;
            border: solid 3px #d7d7d7;
            background-color: #d7d7d7;
        }
        #commonButtonSort {
            margin: 20px 0 20px 0;
            top: 30px;
            height: auto;
        }
        .switchArea {
            width: calc(100% - 50px);
            height: 50px;
            left: calc(50px);
            p {
                width: 50px;
                height: 50px;
            }
        }
    }
</style>